import React, { useState, createContext, useContext, useRef } from 'react'
import { useAvatar } from '../avatar/avatar.context'

const initVoicePropsState = {
  recognitionRef: {},
  onCall: false,
  setOnCall: () => {},
  startSpeechRecognition: () => {},
  idleErrorMessage: '',
  setIdleErrorMessage: () => {},
}

const VoiceContext = createContext(initVoicePropsState)

const useVoice = () => {
  return useContext(VoiceContext)
}

const VoiceProvider = ({ children }) => {
  const { avatarRef, newChat, setSpeaking } = useAvatar()
  const [onCall, setOnCall] = useState(false)
  const [idleErrorMessage, setIdleErrorMessage] = useState('')

  const recognitionRef = useRef(null)

  async function callToAvatar(text) {
    console.log('Speaking:', text)
    const avatar = avatarRef.current
    if (!avatar) return
    await avatar.speak({
      text,
    })
  }

  function handleSpeechRecognitionError(event) {
    if (event.error === 'no-speech') {
      console.log('No speech detected')
      setIdleErrorMessage('No speech detected')
    }
  }

  function handleSpeechRecognitionResult(event) {
    console.log('Recognized results', event.results)

    // const transcript = Array.from(event.results)
    //   .map((result) => result[0].transcript)
    //   .join('')

    const lastResult = event.results[event.results.length - 1]

    setSpeaking(lastResult[0].transcript.trim())

    if (lastResult.isFinal) {
      const message = lastResult[0].transcript.trim()
      newChat(message, 'user')
      callToAvatar(message)
      setSpeaking('')
    }
  }

  function handleSpeechRecognitionEnd(event) {
    console.log('Recognition ended')
    setOnCall(false)
    // if (onCall) {
    //   recognition.start()
    //   console.log('Restarting recognition...', event)
    // }
  }

  function configureSpeechRecognition() {
    console.log('Configuring speech recognition...')
    const recognition = recognitionRef.current
    recognition.lang = 'en-US'
    recognition.interimResults = true
    recognition.continuous = true // Keep listening

    recognition.onerror = handleSpeechRecognitionError
    recognition.onresult = handleSpeechRecognitionResult
    recognition.onend = handleSpeechRecognitionEnd
  }

  async function startSpeechRecognition() {
    console.log('Starting speech recognition...')
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition

    if (!SpeechRecognition) {
      console.error('Speech Recognition API is not supported.')
      return
    }

    const recognition = new SpeechRecognition()
    recognitionRef.current = recognition
    configureSpeechRecognition()
  }

  // useEffect(() => {
  //   startSpeechRecognition()
  // }, [])

  return (
    <VoiceContext.Provider
      value={{
        recognitionRef,
        onCall,
        setOnCall,
        startSpeechRecognition,
        idleErrorMessage,
        setIdleErrorMessage,
      }}
    >
      {children}
    </VoiceContext.Provider>
  )
}

export { VoiceProvider, useVoice }
